import http from './axios';

export interface DataJobDto {
  id?: number;
  jobCode?: number;
  jobGroup?: string;
  jobCron?: number;
  jobDesc?: string;
  // 调度状态：0-停止，1-运行
  triggerStatus?: number;
  // 上次调度时间
  triggerLastTime?: number;
  // 下次调度时间
  triggerNextTime?: number;
  // 最近一次执行状态 500:失败,502:失败(超时),200:成功,0:无
  lastHandleCode?: number;
  status?: number;
}

export interface TriggerJobDto {
  executorParam?: string;
  jobId?: number;
  jobType?: number;
  // 调度类型 0-MANUAL,1-PATCH,2-RERUN
  triggerType?: number;
  handleDataDate?: any;
}


export default class DatajobServices {

  private readonly total_api = '/v1/data/job/countJob';
  private readonly rate_api = '/v1/data/joblog/countJobRate';
  private readonly all_record_api = '/v1/data/joblog/countJobRecord';
  private readonly group_record_api = '/v1/data/joblog/countJobRecordByGroup';

  private readonly page_api = '/v1/data/job/pageList';
  private readonly list_api = '/v1/data/job/list';
  private readonly info_api = '/v1/data/job/info';
  private readonly detail_api = '/v1/data/job/detail';
  private readonly save_api = '/v1/data/job/add';
  private readonly update_api = '/v1/data/job/update';
  private readonly remove_api = '/v1/data/job/remove';
  private readonly start_api = '/v1/data/job/start';
  private readonly trigger_api = '/v1/data/job/trigger';
  private readonly triggerBatch_api = '/v1/data/job/triggerBatch';
  private readonly log_info_api = '/v1/data/joblog/info';
  private readonly log_list1_api = '/v1/data/joblog/list/1';
  private readonly log_list2_api = '/v1/data/joblog/list/2';
  private readonly log_page_api = '/v1/data/joblog/pageList';
  private readonly stop_api = '/v1/data/joblog/logKill';
  private readonly kill_api = '/v1/data/joblog/killJob';

  constructor() {}

  /**  主表单数据 */
  async getListAll(): Promise<any> {
    let res: any = await http.get(this.list_api);
    return res.payload;
  }

  async getTotal(params?: object): Promise<any> {
    let res: any = await http.get(this.total_api, { params: params });
    return res.payload;
  }

  async getPageList(params?: any): Promise<any> {
    let data: any = {
      current: params.current,
      size: params.size,
      jobGroup: params.jobGroup ? params.jobGroup : 1,
      jobCode: params.jobCode ? params.jobCode : '',
      triggerStatus: params.triggerStatus ? params.triggerStatus : -1,
      lastHandleCode: params.lastHandleCode ? params.lastHandleCode : -1,
      jobFlinkName: params.jobFlinkName ? params.jobFlinkName : '',
      glueType: params.glueType ? params.glueType : '',
    };
    let res: any = await http.get(this.page_api, {params: data});
    return res.payload;
  }

  async getInfo(id: number) {
    let res: any = await http.get(this.info_api + '/' + id);
    return res.payload;
  }

  async getDetail(jobCode: string) {
    let res: any = await http.get(this.detail_api + '/' + jobCode);
    return res.payload;
  }

  async update(data: any): Promise<boolean> {
    let res: any = await http.post(this.update_api, data);
    return res.header?.code == 200;
  }

  async getLogPageList(params?: any): Promise<any> {
    let data: any = {
      current: params.page,
      size: params.limit,
      jobGroup: params.jobGroup ? params.jobGroup : 1,
      jobCode: params.jobCode ? params.jobCode : '',
      jobId: params.jobId ? params.jobId : -1,
      logStatus: params.logStatus ? params.logStatus : -1,
      jobName: params.jobFlinkName ? params.jobFlinkName : '',
      timeStart: params.timeStart ? params.timeStart : '',
      timeEnd: params.timeEnd ? params.timeEnd : '',
    };
    let res: any = await http.get(this.log_page_api, {params: data});
    return res.payload;
  }

  async getLog(id: number) {
    let res: any = await http.get(this.log_info_api + '/' + id);
    return res.payload;
  }

  async getLogList(jobId: number): Promise<any> {
    let res: any = await http.get(this.log_list1_api + '/' + jobId);
    return res.payload;
  }

  async getLogList2(jobCode: string): Promise<any> {
    let res: any = await http.get(this.log_list2_api + '/' + jobCode);
    return res.payload;
  }

  async start(id: string | number): Promise<boolean> {
    let params = { id: id };
    let res: any = await http.post(this.start_api, null, { params: params, timeout: 30000 });
    return res.header?.code == 200;
  }

  async kill(data: any): Promise<boolean>{
    let res: any = await http.post(this.kill_api, data);
    return res.header?.code == 200;
  }

  async stop(id: string | number): Promise<boolean>{
    let params = { id: id };
    let res: any = await http.post(this.stop_api, null, { params: params });
    return res.header?.code == 200;
  }
  
  async trigger(data: TriggerJobDto): Promise<boolean>{
    let res: any = await http.post(this.trigger_api, data);
    return res.header?.code == 200;
  }

  async triggerBatch(data: TriggerJobDto[]): Promise<boolean> {
    let res: any = await http.post(this.triggerBatch_api, data);
    return res.header?.code == 200;
  }

  async remove(id: string | number) {
    let res: any = await http.post(this.remove_api + '/' + id);
    return res.header?.code == 200;
  }

    // 作业运行总览
    async getTotalRecord(params?: object): Promise<any> {
      let res: any = await http.get(this.all_record_api, { params: params });
      return res.payload;
    }
  
    async getTotalGroupRecord(params?: object): Promise<any> {
      let res: any = await http.get(this.group_record_api, { params: params });
      return res.payload;
    }
  
    async getRecordRate(params?: object): Promise<any> {
      let res: any = await http.get(this.rate_api, { params: params });
      return res.payload;
    }
}
